const searchVariants = () => {
    document.querySelectorAll('.search-block__form .form-control').forEach(form => {
        form.addEventListener('input', async () => {
            const identSearch = form.parentElement.id;
            if (form.value.length > 3) {
                try {
                    const response = await fetch('/classes/ajax/search/search.php', {
                        method: 'POST',
                        body: JSON.stringify({ gosearch: form.value }),
                        headers: { 'Content-Type': 'application/json; charset=UTF-8' }
                    });

                    const responseText = await response.text();
                    const searchWrapper = form.closest('.search-block');
                    const variantsContainer = searchWrapper.querySelector('.search-block__variants');

                    variantsContainer.innerHTML = responseText;
                    variantsContainer.style.display = 'block';

                    searchWrapper.querySelectorAll('.search-block__option').forEach(option => {
                        option.addEventListener('click', () => {
                            form.value = option.textContent;
                            searchWrapper.querySelector(`#${identSearch}`).submit();
                        });
                    });
                } catch (error) {
                    console.error('Search request failed:', error);
                }
            } else {
                const searchWrapper = form.closest('.search-block');
                const variantsContainer = searchWrapper.querySelector('.search-block__variants');
                variantsContainer.innerHTML = '';
                variantsContainer.style.display = 'none';
            }
        });
    });
};

export default searchVariants;
